import { studentEndpoints } from "../apis";
import toast from "react-hot-toast";
import rzpLogo from '../../assets/Logo/rzp_logo.png'
import { apiConnector } from "../apiconnector";
import { setPaymentLoading } from "../../slices/courseSlice"
import { resetCart } from "../../slices/cartSlice"


const {COURSE_PAYMENT_API , COURSE_VERIFY_API, SEND_PAYMENT_SUCCESS_EMAIL_API} = studentEndpoints;

  //function to load the below written script on runtime 
function loadScript(src) { 
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;

        script.onload = () => {
            resolve(true);
        }

        script.onerror = () => {

            resolve(false);
        }
        document.body.appendChild(script);
    })
}

export async function buyCourse(token, courses, userDetails, navigate,dispatch) {

    // ✅ ADD THIS LOG
  console.error("!!! ERROR: The OLD buyCourse function was called. !!!"); 

    const toastId = toast.loading("Loading...");
    try{
        //load the scripts
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

        //validate
        if(!res){
            toast.error("Razorpay failed to load");
            return;
        }

        //intiate the order
        const orderResponse = await apiConnector("POST",COURSE_PAYMENT_API,
                                    {courses},
                                    {
                                        Authorization:`Bearer ${token}`,
                                    })

        if(!orderResponse.data.success) {
            throw new Error(orderResponse.data.message);
        }

        //options 
        const options = {
            key:process.env.REACT_APP_RAZORPAY_KEY,
            currency:orderResponse.data.data.currency,
            amount:`${orderResponse.data.data.amount}`,
            order_id:orderResponse.data.data.id,
            name:"StudyNotion",
            description:"THank You for Purchasing the Course",
            image:rzpLogo,
            prefill:{
                name:`${userDetails.firstName}`,
                email:userDetails.email,
            },
            handler: function(response){
                //send the mail of successful payment
                sendPaymentSuccessEmail(response, orderResponse.data.data.amount, token);

                //verify payment
                verifyPayment({...response, courses}, token, navigate ,dispatch);
            },

        }
        const paymentObject = new window.Razorpay(options)
         
        paymentObject.open()
        paymentObject.on("payment.failed", function (response) {
        toast.error("Oops! Payment Failed.")
        console.log(response.error)
    })

    }catch(error){
      console.log("PAYMENT API ERROR...",error);
      toast.error("Could not make payment: ");
    }
    toast.dismiss(toastId);
}


async function sendPaymentSuccessEmail(response, amount, token) {
   try{
    await apiConnector("POST",SEND_PAYMENT_SUCCESS_EMAIL_API,{
        order_id:response.razorpay_order_id,
        payment:response.razorpay_payment_id,
        amount,
    },{
        Authorization: `Bearer ${token}`
    })

   }catch(error){
     console.log("Payment success email error",error)
   }

}


//verify payment
async function verifyPayment(bodyData, token, navigate, dispatch) {
    const toastId = toast.loading("Verify Payment....");
    dispatch(setPaymentLoading(true));
    try{
        const response = await apiConnector("POST",COURSE_VERIFY_API, bodyData, {
            Authorization:`Bearer ${token}`,
        })

        if(!response.data.success) {
            throw new Error(response.data.message);
        }
        toast.success("Payment Successful, you are added to the course");
        navigate("/dashboard/enrolled-courses");

        dispatch(resetCart());
    }catch(error) {
        console.log("Payment verify error: ",error);
        toast.error("Could not verify payment");
    }
    toast.dismiss(toastId);
}




